// Dependencies
import Diplomas from 'layouts/diplomas';


class PageAbout {
  /**
   * Constructor: Home Page Constructor.
   */
  constructor() {
    // Root
    this._root = document.querySelector('[layout="page-about"]');

    // Dependencies
    this.Diplomas = new Diplomas();
  }


  /**
   * Resize: Resize the page.
   */
  resize() {
    this.Diplomas.resize();
  }
}

export default PageAbout;


// WEBPACK FOOTER //
// ./src/js/templates/page-about.js